import { render, staticRenderFns } from "./ClassOfService.vue?vue&type=template&id=a1593972&"
import script from "./ClassOfService.vue?vue&type=script&lang=js&"
export * from "./ClassOfService.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports